<div [ngSwitch]="currentStep"
     class="next-aztec-scanner-section">

  <app-next-aztec-scanner-introduction *ngSwitchCase="ScannerStep.INTRODUCTION"
                                  (action)="handleAction($event)">
  </app-next-aztec-scanner-introduction>

  <app-next-aztec-scanner-scanner *ngSwitchCase="ScannerStep.SCANNER"
                     (action)="handleAction($event)">
  </app-next-aztec-scanner-scanner>

  <app-next-aztec-scanner-notification *ngSwitchCase="ScannerStep.NOTIFICATION"
                                  (action)="handleAction($event)">
  </app-next-aztec-scanner-notification>
</div>
